module.exports = __webpack_public_path__ + "img/main.1e326c7e.png";